import { string, object } from 'yup';

import { message } from 'shared/helpers/constants/notes/createNoteConstants';

export const CreateSettlementNoteYup = object().shape({
  note: string().trim().max(1000, message.INVALID_NOTE_LENGTH(1000)).required(message.INVALID_NOTE),
});
